import apiClient, { extractData } from "./client";

export async function createCashEntitlements(data) {
  const response = await apiClient.post("/cash-entitlements", data);
  return extractData(response);
}

export async function getCashEntitlements() {
  const response = await apiClient.get("/cash-entitlements");
  return extractData(response);
}

export async function getCashEntitlementPayrollSources(employeeId) {
  const response = await apiClient.get("/cash-entitlements/payroll-sources", {
    params: { employeeId },
  });
  return extractData(response);
}

export async function getPendingCashEntitlementDisbursement() {
  const response = await apiClient.get(
    "/cash-entitlements/pending-disbursement",
  );
  return extractData(response);
}

export async function getAssignedCashEntitlementDisbursement() {
  const response = await apiClient.get(
    "/cash-entitlements/assigned-disbursement",
  );
  return extractData(response);
}

export async function getCashEntitlementDisbursementLedger() {
  const response = await apiClient.get(
    "/cash-entitlements/disbursement-ledger",
  );
  return extractData(response);
}

export async function assignCashEntitlementDisbursement(id, data) {
  const response = await apiClient.post(
    `/cash-entitlements/${id}/assign-disbursement`,
    data,
  );
  return extractData(response);
}

export async function confirmCashEntitlementDisbursement(id) {
  const response = await apiClient.post(
    `/cash-entitlements/${id}/confirm-disbursement`,
  );
  return extractData(response);
}

export async function reportCashEntitlementNotDisbursed(id, data = {}) {
  const response = await apiClient.post(
    `/cash-entitlements/${id}/report-not-disbursed`,
    data,
  );
  return extractData(response);
}

export async function returnCashEntitlementDisbursement(id, data = {}) {
  const response = await apiClient.post(
    `/cash-entitlements/${id}/return-disbursement`,
    data,
  );
  return extractData(response);
}

export async function cancelCashEntitlement(id, data = {}) {
  const response = await apiClient.post(`/cash-entitlements/${id}/cancel`, data);
  return extractData(response);
}
